/*! Auric quick view — fetches product markup via Section Rendering API into a modal */
(function () {
  'use strict';

  var modal = document.getElementById('QuickViewModal');
  if (!modal) return;

  function open(handle) {
    modal.innerHTML = '<div class="quick-view-modal__backdrop" data-quick-view-close></div>' +
      '<div class="quick-view-modal__panel"><button class="icon-btn" data-quick-view-close aria-label="Close" style="position:absolute;top:12px;right:12px;z-index:2;"></button><p style="padding:48px;text-align:center;">Loading…</p></div>';
    modal.classList.add('is-open');
    modal.removeAttribute('aria-hidden');

    fetch('/products/' + handle + '?section_id=quick-view')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var panel = modal.querySelector('.quick-view-modal__panel');
        panel.innerHTML = '<button class="icon-btn" data-quick-view-close aria-label="Close" style="position:absolute;top:12px;right:12px;z-index:2;">&times;</button>' + html;
      });
  }

  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    setTimeout(function () { modal.innerHTML = ''; }, 300);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view-open]');
    if (trigger) { open(trigger.getAttribute('data-product-handle')); }
    if (e.target.closest('[data-quick-view-close]')) { close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
